module.exports = __webpack_public_path__ + "static/media/step01.382bb69a.svg";